import MenuButton from '@/features/ui/buttons/components/MenuButton'
import MenuItem from '@/features/ui/buttons/components/MenuButton/parts/MenuItem'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ContextMenuProps {
    onInsertNote: () => void
}

const ContextMenu: FC<ContextMenuProps> = ({ onInsertNote }) => {
    const [open, setOpen] = useState(false)

    const { t } = useTranslation()

    const handleToggleOpen = () => {
        setOpen((previousOpen) => !previousOpen)
    }

    const handleInsertNotePress = () => {
        setOpen(false)
        onInsertNote()
    }

    return (
        <MenuButton onToggleOpen={handleToggleOpen} open={open}>
            <MenuItem
                label={t('common.insertNoteFormContent.insertNote')}
                onPress={handleInsertNotePress}
                divider={false}
            />
        </MenuButton>
    )
}

export default ContextMenu
